export default class AppState {
  token: string;

  constructor(token: string = '') {
    this.token = token;
  }
}
